import React, { useRef, useEffect } from 'react';

declare const google: any;

interface IProps {
  setGoogleData: (data: any) => void;
  disabled: boolean;
}

const AutoComplete: React.FC<IProps> = ({ setGoogleData, disabled }) => {
  const autoCompleteRef = useRef<any>(null);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const options = {
    fields: ['address_components'],
  };
  useEffect(() => {
    if (
      typeof google !== "undefined" &&
      google.maps
    ) {
      autoCompleteRef.current = new google.maps.places.Autocomplete(
        inputRef.current,
        options
      );
      autoCompleteRef.current.addListener('place_changed', async function () {
        const place = await autoCompleteRef.current.getPlace();

        setGoogleData(place.address_components);
      });
    }
  }, []);
  return <input className='' disabled={disabled} ref={inputRef} />;
};
export default AutoComplete;
